import {
    HttpClient,
    HttpResponse,
} from '@angular/common/http';
import {
    Inject,
    Injectable,
} from '@angular/core';
import { Observable } from 'rxjs';
import {
    map,
    tap,
} from 'rxjs/operators';

import { IDownloadResponse } from './download.model';

@Injectable()
export class DownloadService {

    constructor(
        @Inject(Window) private window: Window,
        private http: HttpClient,
    ) { }

    public download(url: string, command?: any, filename?: string): Observable<IDownloadResponse> {
        return this.http.post(url, command, { responseType: 'blob', observe: 'response' })
            .pipe(
                map((response: HttpResponse<Blob>) => {
                    filename = filename || response.headers.get('Content-Disposition').split('filename=')[1];

                    return <IDownloadResponse>{
                        filename,
                        data: new Blob([response.body], { type: response.headers.get('Content-Type') }),
                    };
                }),
                tap((downloadResponse: IDownloadResponse) => {
                    const filename: string = decodeURIComponent(downloadResponse.filename);
                    if (this.window.navigator.msSaveBlob) { // IE
                        this.window.navigator.msSaveOrOpenBlob(downloadResponse.data, filename);
                    } else {
                        const url: string = URL.createObjectURL(downloadResponse.data);
                        const anchor: HTMLAnchorElement = document.createElement('a');
                        document.body.appendChild(anchor);
                        anchor.setAttribute('style', 'display: none');
                        anchor.href = url;
                        anchor.download = filename;
                        anchor.click();
                        URL.revokeObjectURL(url);
                        anchor.remove();
                    }
                }),
            );
    }
}
